module.exports = {"540526100":"措美镇","540526101":"哲古镇","540526200":"乃西乡","540526201":"古堆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540526.json
// module id = 2865
// module chunks = 0